// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/common.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/common.proto.
 */
export const file_tabgraph_v1_common: GenFile = /*@__PURE__*/
  fileDesc("Chh0YWJncmFwaC92MS9jb21tb24ucHJvdG8SC3RhYmdyYXBoLnYxIjsKCFBhZ2VJbmZvEg0KBXRpdGxlGAEgASgJEgsKA3VybBgCIAEoCRITCgtmYXZpY29uX3VybBgDIAEoCSIrCgpQYWdpbmF0aW9uEg0KBWxpbWl0GAEgASgFEg4KBmN1cnNvchgCIAEoCSI7ChJQYWdpbmF0aW9uUmVzcG9uc2USEwoLbmV4dF9jdXJzb3IYASABKAkSEAoIaGFzX21vcmUYAiABKAhCR1pFZ2l0aHViLmNvbS9zdHJhdHVzc3R1ZGlvcy90YWJncmFwaC9iYWNrZW5kL2dlbi90YWJncmFwaC92MTt0YWJncmFwaHYxYgZwcm90bzM");

/**
 * PageInfo carries the displayable metadata for a single browser page.
 *
 * @generated from message tabgraph.v1.PageInfo
 */
export type PageInfo = Message<"tabgraph.v1.PageInfo"> & {
  /**
   * title is the page <title> as captured by the browser.
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * url is the full URL prior to canonicalization.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * favicon_url is the URL of the page's favicon, if available.
   *
   * @generated from field: string favicon_url = 3;
   */
  faviconUrl: string;
};

/**
 * Describes the message tabgraph.v1.PageInfo.
 * Use `create(PageInfoSchema)` to create a new message.
 */
export const PageInfoSchema: GenMessage<PageInfo> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_common, 0);

/**
 * Pagination carries cursor-based pagination input parameters.
 *
 * @generated from message tabgraph.v1.Pagination
 */
export type Pagination = Message<"tabgraph.v1.Pagination"> & {
  /**
   * limit is the maximum number of results to return.
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * cursor is an opaque continuation token from a previous response.
   *
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message tabgraph.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_common, 1);

/**
 * PaginationResponse carries cursor-based pagination output parameters.
 *
 * @generated from message tabgraph.v1.PaginationResponse
 */
export type PaginationResponse = Message<"tabgraph.v1.PaginationResponse"> & {
  /**
   * next_cursor is an opaque token that can be supplied as Pagination.cursor to
   * retrieve the next page. Empty when there are no further results.
   *
   * @generated from field: string next_cursor = 1;
   */
  nextCursor: string;

  /**
   * has_more is true when additional results are available beyond this page.
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message tabgraph.v1.PaginationResponse.
 * Use `create(PaginationResponseSchema)` to create a new message.
 */
export const PaginationResponseSchema: GenMessage<PaginationResponse> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_common, 2);

